import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-campus-life',
  templateUrl: './campus-life.component.html',
  styleUrls: ['./campus-life.component.scss']
})
export class CampusLifeComponent implements OnInit {

  imgUrl:string[]=[
    '/assets/img/campus/1.jpg',
    '/assets/img/campus/2.jpg',
    '/assets/img/campus/3.jpg',
    '/assets/img/campus/4.jpg',
    '/assets/img/campus/5.jpg',
    '/assets/img/campus/6.jpg',
    '/assets/img/campus/7.jpg',
    '/assets/img/campus/8.jpg',
    '/assets/img/campus/9.jpg',
    
  ]

  constructor() { }

  ngOnInit(): void {
  }

}
